/**
 * New Business model. Contains all the required fields for a new business to be created
 */
import { Business } from './business.model';
import { Airport } from '../../airport/models/airport.model';
import { BusinessTag } from './business-tag.model';

export class NewBusiness extends Business {
  airport: Airport;
  businessTags: BusinessTag[];
  userAdded: boolean;

  serialize(): any {
    this.location = this.airport.location;
    const result = {
      name: this.name,
      facilityType: this.facilityType,
      addresses: this.serializeAddresses(),
      airports: [{
        airportId: this.airport.airportId || null,
        faaId: this.airport.faaId || null,
        icaoId: this.airport.icaoId || null
      }],
      location: this.serializeLocation(),
      businessTags: this.businessTags,
      userAdded: this.userAdded,
      phone1: this.phone,
      fax: this.fax,
      webAddress: this.webAddress,
      emailAddress: this.email
    };
    result.addresses[0].country = 'US';
    return result;
  }
}
